

export const kebab = {
  methods: {
    toKebab: function(val) {
      return val.toLowerCase().replace(/[\s]/g, "-");
    },
  }
}

export const slugFunctions = {
  methods: {
    toSlug(val) {
      return encodeURI(val.toLowerCase().replace(/[\s]/g, "-"));
    }
  }
}

export const imageFunctions = {
  methods: {
    staticUrl(url) {
      return require('../'+url)
    },

  }
}

export const stringFunctions = {
  methods: {
    parseMarkdown(string) {
      const linkPattern = /\[([\w\s]+)\]\(((?:http[s]?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+)\)/

      return string.replace(linkPattern, function(match, title, url) {
        return `<a href='${url}'>${title}</a>`;
      });
    }
  }
}